<template>
  <div class="browse">
    <el-card class="box-card tablecard textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-cogs fs14" /> Change Log</span>
      </div>
      <div>
      <el-row class="mt20 mb10">
        <el-button size="small" class="ml10 mt10" type="danger" icon="el-icon-plus" @click="handleNew">新增</el-button>
        <div class="floatRight" style="margin-bottom: 10px;">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <div>
          <el-table
            :data="tableData"
            border
            stripe
            v-loading="loading"
            @sort-change="handleSort"
            class="pointer"
            style="width: 100%">
              <!-- <el-table-column
                v-for="(item, index) of tableHeader"
                :fixed = "item.fixed"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                :show-overflow-tooltip="isOverflow">
              </el-table-column> -->
            <el-table-column
              label="ID"
              prop="id"
              width="70"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="logContent"
              prop="logContent"
              width="150"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="rmk"
              prop="rmk"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="logUser"
              prop="logUser"
              width="100"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="logDate"
              prop="logDate"
              width="200"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                <el-popconfirm
                  class="ml10"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定要执行删除操作吗？"
                  @confirm="handleDelete(scope.$index, scope.row)">
                  <el-button slot="reference" type="text" size="small">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="allNum"
            :page-size="pageSize"
            @current-change="handleChangepage"
            class="pagination mb10">
          </el-pagination>
        </div>
      </el-row>
      </div>
    </el-card>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="60%">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="logContent" :label-width="formLabelWidth" prop="logContent">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="form.logContent">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
            v-model="form.rmk">
          </el-input>
        </el-form-item>
        <el-form-item label="记录人" :label-width="formLabelWidth" prop="logUser">
          <el-input v-model="form.logUser" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">取 消</el-button>
        <el-button type="primary" @click="handleNewLog('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getChangeLogList, addChangeLog, uptChangeLog, delChangeLog } from '@/api'
  export default {
    name: 'changelog',
    data() {
      const eHeaders = [
        { label: 'Id', prop: 'id', sortable: true, align: 'center', fixed: false },
        { label: 'logContent', prop: 'logContent', sortable: true , align: 'center', fixed: false },
        { label: 'rmk', prop: 'rmk', sortable: true, align: 'center', fixed: false },
        { label: 'logUser', prop: 'logUser', sortable: true, align: 'center', fixed: false },
        { label: 'logDate', prop: 'logDate', sortable: true, align: 'center', fixed: false },
      ]
      return {
        loading: true,
        tableData: [],
        allNum: 0,
        pageSize: 20,
        ajax_Data: {
          search: {
            keyword: ''
          },
          order: {
            item: '',
            type: ''
          },
          page: {
            startPage: 1,
            pageLength: 20
          }
        },
        tableHeader: eHeaders,
        isOverflow: true,
        dialogTitle: '新增',
        dialogFormVisible: false,
        form: {
          id: 0,
          logContent: '',
          rmk: '',
          logUser: '',
        },
        isEdit: false,
        ajax_data_add: {
          logContent: '',
          logUser: '',
          rmk: ''
        },
        ajax_data_edit: {
          id: 0,
          logContent: '',
          logUser: '',
          rmk: ''
        },
        ajax_data_del: {
          id: 0
        },
        rules: {
          logContent: [
            { required: true, message: '请输入域名', trigger: 'blur' },
            { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
          ],
          logUser: [
            { required: true, message: '请输入提醒开始时间', trigger: 'blur' }
          ]
        },
        formLabelWidth: '120px'
      }
    },
    mounted() {
      
    },
    created() {
      this.handleChangelogList()
    },
    methods: {
      handleChangepage (val) {
        this.loading = true
        this.ajax_Data.page.startPage = val
        this.handleChangelogList()
      },
      handleSort (column, prop, order) {
        console.log(column, prop, order)
        this.loading = true
        this.ajax_Data.order.item = column.prop
        this.ajax_Data.order.type = column.order
        if (column.order !== null && column.prop !== null) {
          this.handleChangelogList()
        } else {
          this.loading = false
        }
      },
      handleNew() {
        this.dialogFormVisible = true
        this.isEdit = false
        this.dialogTitle = '新增'
        this.form.logContent = ''
        this.form.logUser = ''
        this.form.rmk = ''
      },
      handleEdit(row) {
        this.isEdit = true
        this.dialogTitle = '编辑'
        this.dialogFormVisible = true
        this.form.id = row.id
        this.form.logContent = row.logContent
        this.form.logUser = row.logUser
        this.form.rmk = row.rmk
      },
      handleNewLog(formName) {
        // console.log(this.form)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.isEdit) {
              // this.ajax_data_edit.userEmail = this.ruleForm.userEmail
              // const newDate = new Date('2023-10-01')
              this.ajax_data_edit.id = this.form.id
              this.ajax_data_edit.logContent = this.form.logContent
              this.ajax_data_edit.logUser = this.form.logUser
              this.ajax_data_edit.rmk = this.form.rmk
              console.log(this.ajax_data_edit)
              uptChangeLog(this.ajax_data_edit).then((res) => {
                this.$message({
                  message: '修改成功!',
                  type: 'success'
                });
                this.handleChangelogList()
              })
            } else {
              this.ajax_data_add.id = this.form.id
              this.ajax_data_add.logContent = this.form.logContent
              this.ajax_data_add.logUser = this.form.logUser
              this.ajax_data_add.rmk = this.form.rmk
              console.log(this.ajax_data_add)
              addChangeLog(this.ajax_data_add).then((res) => {
                this.$message({
                  message: '添加成功!',
                  type: 'success'
                });
                this.handleChangelogList()
              })
            }
          }
          else {
            this.$message({
              message: '请检查!',
              type: 'error'
            });
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(index, row)
        this.ajax_data_del.id = row.id
        delChangeLog(this.ajax_data_del).then((res) => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success'
          });
          this.handleChangelogList()
        })
      },
      handleCancel() {
        this.dialogFormVisible = false
      },
      handleChangelogList() {
        getChangeLogList(this.ajax_Data).then(res => {
          this.loading = false
          this.tableData = res.result
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .changelog {
    
  }
</style>
